import React from "react";
import { LOGO, BRAND } from "@/lib/site";

/**
 * LotWise mark — displays the geometric W logo alongside the wordmark.
 * `variant` = "light" (for dark backgrounds) or "dark" (for light backgrounds).
 *
 * The supplied logo assets already carry their own background (black square
 * or white square), so we render them at their true aspect ratio via
 * object-contain and skip any wrapping colour block that would crop or
 * distort the mark.
 */
export default function Logo({ variant = "dark", showWordmark = true, className = "" }) {
  const src = variant === "light" ? LOGO.wOnBlack : LOGO.wOnWhite;
  const wordColor = variant === "light" ? "text-white" : "text-black";
  return (
    <div
      data-testid="lw-logo"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <img
        src={src}
        alt="LotWise Auto"
        loading="eager"
        className="h-10 w-10 shrink-0 object-contain"
      />
      {showWordmark && (
        <span
          className={`font-display text-[19px] font-bold tracking-tight ${wordColor}`}
        >
          {BRAND.short}
          <span className="ml-1 font-medium opacity-60">Auto</span>
        </span>
      )}
    </div>
  );
}
